<script>
export default {
  name: "videoPlayWidget",
  data () {
    return {

    }
  },
  props: {
    videoUrl: {
      type: String,
      default: ""
    },
    videoType: {
      type: String,
      default: "video/mp4"
    }
  },
}
</script>

<template>
 <el-row>
   <el-col :span="24" class="video-outer-wrapper">
     <div class="video-wrapper">
       <video
           class="video-style"
           :autoplay="true"
           :muted="true"
           :loop="true"
       >
         <source :src="videoUrl" type="video/mp4">
       </video>
     </div>

   </el-col>
 </el-row>
</template>

<style scoped lang="scss">
.video-outer-wrapper{
  display: flex;
  justify-content: center;
  padding: 20px;
}
.video-wrapper{
  width: 75%;
  border-radius: 15px;

}
.video-style {
  width: 100%;
  object-fit: cover;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/videoPlayWidget.vue